import React, { useCallback, useState, useEffect, useContext } from "react";
import { isValid } from "date-fns";
import { convertToLocalTime } from "date-fns-timezone";
import { DesktopDatePicker, } from "@mui/x-date-pickers/DesktopDatePicker";
import makeStyles from "@mui/styles/makeStyles";
import AccountContext from "../account/AccountContext";
import { convertToTZ } from "../DateTimeSelect";
import useDateValidator from "../hooks/useDateValidator";
var useStyles = makeStyles(function () { return ({
    width: {
        width: "100%",
    },
}); });
export default (function (_a) {
    var value = _a.value, minDate = _a.minDate, maxDate = _a.maxDate, onChange = _a.onChange, required = _a.required, disabled = _a.disabled, label = _a.label;
    var timeZone = useContext(AccountContext).timeZone;
    var minToTimeZone = minDate ? convertToTZ(minDate, timeZone) : undefined;
    var maxToTimeZone = maxDate ? convertToTZ(maxDate, timeZone) : undefined;
    var _b = useState(value), inputDate = _b[0], setInputDate = _b[1];
    var _c = useDateValidator({
        date: inputDate,
        min: minToTimeZone,
        max: maxToTimeZone,
    }), hasError = _c.hasError, errorMessage = _c.errorMessage;
    var classes = useStyles();
    useEffect(function () {
        setInputDate(convertToTZ(value, timeZone));
    }, [value, timeZone]);
    var convertOnChange = useCallback(function (date) {
        if (isValid(date)) {
            if (date && timeZone) {
                onChange(convertToLocalTime(date, { timeZone: timeZone }));
            }
            else {
                onChange(date);
            }
        }
        setInputDate(date);
    }, [timeZone, onChange]);
    return (React.createElement(DesktopDatePicker, { format: "MM/dd/yyyy", disabled: disabled, label: label, value: inputDate, minDate: minToTimeZone, maxDate: maxToTimeZone, slotProps: {
            textField: {
                className: classes.width,
                variant: "standard",
                error: hasError,
                helperText: errorMessage,
                required: required,
            },
        }, onChange: convertOnChange }));
});
//# sourceMappingURL=index.js.map